/**
 * Puente entre IDs del motor EDX y entries de conocimiento Genie.
 */

import type { TemporalCourse } from './types';

/** patternId del analyzer → entry id canónico (fallback estático) */
export const PATTERN_TO_KNOWLEDGE: Record<string, string> = {
  // Core DiagnosticPatternAnalyzer
  carpal_tunnel_syndrome: 'carpal_tunnel_syndrome',
  polyneuropathy: 'polyneuropathy',
  radiculopathy: 'radiculopathy',
  myopathy: 'myopathy',
  plexopathy: 'plexopathy',
  brachial_plexopathy: 'plexopathy',
  mononeuropathy: 'mononeuropathy',
  myasthenia_gravis: 'myasthenia_gravis',
  motor_neuron_disease: 'motor_neuron_disease',

  // Variantes declarativas EMG
  carpal_tunnel_syndrome_mild: 'carpal_tunnel_syndrome',
  carpal_tunnel_syndrome_moderate: 'carpal_tunnel_syndrome',
  carpal_tunnel_syndrome_severe: 'carpal_tunnel_syndrome',
  tarsal_tunnel_syndrome: 'mononeuropathy',
  als: 'motor_neuron_disease',
  acute_axonal_neuropathy: 'gbs',
  chronic_axonal_neuropathy: 'polyneuropathy',
  demyelinating_neuropathy: 'demyelinating_neuropathy',
  normal: 'polyneuropathy',

  // ExpandedPatternAnalyzer
  cidp: 'cidp',
  gbs: 'gbs',
  multifocal_motor_neuropathy: 'multifocal_motor_neuropathy',
  lambert_eaton: 'lambert_eaton',
  ulnar_neuropathy_elbow: 'ulnar_neuropathy_elbow',
  peroneal_neuropathy: 'peroneal_neuropathy',
  inflammatory_myopathy: 'inflammatory_myopathy',
  myotonic_dystrophy: 'myotonic_dystrophy',
  small_fiber_neuropathy: 'small_fiber_neuropathy',
  axonal_cold_temperature_corrected: 'polyneuropathy',
};

/** Resolución contextual cuando un patrón genérico admite varios entries */
const CONTEXTUAL_OVERRIDES: Array<{
  patternId: string;
  when: { temporalCourse?: TemporalCourse };
  entryId: string;
}> = [
  {
    patternId: 'demyelinating_neuropathy',
    when: { temporalCourse: 'acute' },
    entryId: 'gbs',
  },
  {
    patternId: 'demyelinating_neuropathy',
    when: { temporalCourse: 'subacute' },
    entryId: 'gbs',
  },
  {
    patternId: 'demyelinating_neuropathy',
    when: { temporalCourse: 'chronic' },
    entryId: 'cidp',
  },
  {
    patternId: 'acute_axonal_neuropathy',
    when: { temporalCourse: 'chronic' },
    entryId: 'polyneuropathy',
  },
];

export function resolveKnowledgeEntryId(
  patternId: string,
  options?: { temporalCourse?: TemporalCourse }
): string {
  for (const rule of CONTEXTUAL_OVERRIDES) {
    if (rule.patternId !== patternId) continue;
    if (
      rule.when.temporalCourse &&
      options?.temporalCourse !== rule.when.temporalCourse
    ) {
      continue;
    }
    return rule.entryId;
  }
  return PATTERN_TO_KNOWLEDGE[patternId] ?? patternId;
}
